import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('sheet_rate', '/sheet_rates')
const actions = generator.generate()

export default actions
